/* @flow */

/* search endpoints */
export const iocsEndpoint = `/services/search/v2/iocs`;
export const reportsEndpoint = `/services/search/v2/reports`;

/* page size for queries */
export const pageSize = 20;


/* Search 2.0 endpoints */
export const searchV3Endpoint = `/services/search/v3`;
export const searchV3ReportEndpoint = `/services/search/v3/reports`;
export const searchV3EntityEndpoint = `/services/search/v3/entities`;
export const UPDATE_ENTIRE_QUERY_OBJECT = 'all';
export const SORTER = 'sort';


// WEBPACK FOOTER //
// ./src/app/modules/search/constants.js